
    import { Component, Prop, Vue } from 'vue-property-decorator'
    import { Appointment } from '@/app/appointment/entities/appointment.entity'

    @Component
    export default class TeamsButton extends Vue {
        @Prop({ type: Object, required: true }) appointment!: Appointment
    }
